module.exports = __webpack_public_path__ + "static/media/endosee-logo-pwa@2x.b518bc94.jpg";